// TODO: Tratar entrada de números negativos
function toStringBRL(entrada) {
    var formatado = '';
    var strBase = entrada.toString();
    var pad = "000";

    if (strBase.length <= 2) {
        strBase = pad.substring(0, pad.length - strBase.length) + strBase
    }

    formatado = strBase.slice(0, strBase.length-2) + ',' + strBase.slice(strBase.length-2)

    return formatado;
}

export default toStringBRL